import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Dav } from '../../../dav/shared/dav';
import { DavService } from '../../../dav/shared/dav.service';

@Component({
  selector: 'app-dav-param-list',
  templateUrl: './dav-param-list.component.html',
  styleUrls: ['./dav-param-list.component.scss']
})
export class DavParamListComponent implements OnInit, OnDestroy {

  davs: MatTableDataSource<Dav> = new MatTableDataSource<Dav>();
  displayedColumns = ['site', 'nom', 'partenaire', 'adresse_serveur', 'actions'];

  private sub: Subscription;

  constructor(
    private davService: DavService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.sub = this.davService.getDavs().subscribe(
      davs => {
        return this.davs.data = davs.sort((a, b) => a.nom > b.nom ? 1 : -1)
      });
  }

  ngOnDestroy() {
    if (this.sub != null) {
      this.sub.unsubscribe();
    }
  }

  applyFilter(filterValue: string) {
    this.sub.unsubscribe();
    this.sub = this.davService.getDavs(filterValue).subscribe(
      davs => {
        return this.davs.data = davs.sort((a, b) => a.nom > b.nom ? 1 : -1)
      });
  }

  editDav(dav: Dav) {
    this.router.navigate(['../', dav.id], {
      relativeTo: this.route
    });
  }
}
